<div class="card mb-3">
    <div class="card-body">
        <div class="card-title h4">Entries</div>
        <div class="card-text">
            <app-entry-list [entries]="entries"></app-entry-list>
        </div>
    </div>
</div>